import React from 'react'

export const useMainQueryKey = () =>
  React.useMemo(() => ['CoreMembersListPage_Main'], [])
